import { connect } from 'react-redux'
import PrecedentsContentHeader from 'pages/documentscontent/PrecedentsContentHeader'
import { isRoles } from 'redux/actions'

const mapStateToProps = (state) => ({
  userIs: (props) => isRoles(state, props),
  aol: state.aol.name
})

export default connect(mapStateToProps, null)(PrecedentsContentHeader)
